import { useState, useCallback } from "react";

// currentMonth = 1. dzień wyświetlanego miesiąca (czas lokalny). Wcześniej był tu następny miesiąc,
// bo DayPilot czytał obiekt Date w UTC (północ 1.11 w Polsce = 31.10 w UTC) i pokazywał poprzedni;
// teraz DayPilot dostaje datę jako tekst (toDayPilotDate), więc przesunięcie nie jest potrzebne.
export const useCalendarNavigation = () => {
  const [currentMonth, setCurrentMonth] = useState(() => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  });

  const handlePreviousMonth = useCallback(() => {
    setCurrentMonth(prev => new Date(prev.getFullYear(), prev.getMonth() - 1, 1));
  }, []);

  const handleNextMonth = useCallback(() => {
    setCurrentMonth(prev => new Date(prev.getFullYear(), prev.getMonth() + 1, 1));
  }, []);

  const handleToday = useCallback(() => {
    const today = new Date();
    setCurrentMonth(new Date(today.getFullYear(), today.getMonth(), 1));
  }, []);

  return {
    currentMonth,
    handlePreviousMonth,
    handleNextMonth,
    handleToday,
  };
};
